export const DATE_ASSIGNMENT = {
  FIXED: "FIXED",
  RESPECTIVE: "RESPECTIVE",
} as const;

export type DateAssignmentType = (typeof DATE_ASSIGNMENT)[keyof typeof DATE_ASSIGNMENT];
